import { CompanySettings, CurrencySettings, LicenseTester } from "@mcleod/core";
import { LookupModelSelectionEvent, DropdownSelectionEvent, LookupModelSearchEvent, ChangeEvent } from "@mcleod/components";
import { getDispatchControlBoolean, LMECompanySettings } from "@mcleod/general";
import { AutogenLayoutDuplicateControlSlideout } from "./autogen/AutogenLayoutDuplicateControlSlideout";

export class DuplicateControlSlideout extends AutogenLayoutDuplicateControlSlideout {
    public companyIds: Array<string> = [];
    public hasDuplicateAfterOrderEntry: boolean = false;
    public hasDuplicate: boolean = false;

    override onLoad(): void | Promise<void> {
        const partialShipmentEnabled = CompanySettings.get().partial_shipment_enabled;
        const partialShipmentLicensed = CompanySettings.get().partial_shipment_licensed;

        const multiCurrencyEnabled = CurrencySettings.getSingleton().multiCurrencyEnabled();
        const multiCurrencyLicensed = LicenseTester.testPackage("com.tms.client.lib.multicurrency");

        const ltlEnabled = LMECompanySettings.getSingleton().isLtl();
        const ltlLicensed = LicenseTester.testPackage("com.tms.client.loadmaster.brltl") ||
            LicenseTester.testPackage("com.tms.client.loadmaster.lmltl");

        const containerEnabled = getDispatchControlBoolean("is_container_active", false);
        const containerLicensed = LicenseTester.testPackage("com.tms.client.loadmaster.container");

        this.panelPartialShipment.visible = partialShipmentEnabled && partialShipmentLicensed;
        this.panelMulticurrency.visible = multiCurrencyEnabled && multiCurrencyLicensed;
        this.panelLtl.visible = ltlEnabled && ltlLicensed;
        this.panelContainer.visible = containerEnabled && containerLicensed;

        this.switchClearExciseTaxes.visible = multiCurrencyEnabled && multiCurrencyLicensed;
    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxCopyToCompany. */
    textboxCopyToBeforeLookupModelSearch(event) {
        // This filters out the current company and any companies that already have a copy control record.
        const filters = [
            `!${LMECompanySettings.get().id}`,
            ...this.companyIds.map(id => `!${id}`)
        ];
        event.filter.id = filters.join(" && ");
    }

    /** This is an event handler for the onLookupModelSelection event of textboxCopyToCompany. */
    textboxCopyToCompanyOnLookupModelSelection(event: LookupModelSelectionEvent) {
        const deselectedId = event.deselection?.get("id")
        const selectedId = event.selection?.get("id")

        if(deselectedId) this.companyIds = this.companyIds.filter(id => id !== deselectedId)
        if(selectedId) this.companyIds.push(selectedId)
    }

    /** This is an event handler for the afterDropdownSelection event of textboxCopyType. */
    textboxCopyTypeAfterDropdownSelection(event: DropdownSelectionEvent) {
        const copyTb = this.textboxCopyTo;
        const isCopyTo = event.selection.value === "C";
        if (isCopyTo) {
            copyTb.visible = true;
            copyTb.required = true;
            this.panelActions.visible = true;
        } else {
            this.companyIds = this.companyIds.filter(id => id !== this.activeRow.get("copy_to_company"));
            copyTb.clear();
            copyTb.visible = false;
            copyTb.required = false;
            this.panelActions.visible = false;
        }
    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxLBillTo. */
    handleMulticompanyLookupModelSearch(event: LookupModelSearchEvent) {
        const companyId = this.textboxCopyTo.dataSource?.activeRow?.get("copy_to_company");
        if (!companyId) event.preventDefault();
        event.filter.company_id = companyId;
        event.filter.is_active = "Y";
        event.filter.type_of = "C";
    }

    /** This is an event handler for the onChange event of textboxCopyTo. */
    textboxCopyToOnChange(event: ChangeEvent) {
        if (event.userInitiatedChange) {
            this.textboxCopyBillTo.clear();
            this.textboxCCtrlParty.clear();
            this.textboxCopyOvrdPayee.clear();
            this.textboxCopyRevenueId.clear();
        }
    }
}
